const CHART_WIDTH = "100%";

const CHART_HEIGHT = "100%";

const AREA_COLOR = "#68ADEE";

const CHART_MARGINS = { top: 0, right: 0, bottom: 0, left: 0 };

export { CHART_WIDTH, CHART_HEIGHT, AREA_COLOR, CHART_MARGINS };
